import React from 'react';

import { withTheme } from 'styled-components/macro';

import { Grid, Hidden, Toolbar } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';

import { historyRef } from '~/services/history';

import NotificationsDropdown from '~/components/NotificationsDropdown';
import UserDropdown from '~/components/UserDropdown';
import Settings from '~/components/Settings';

import { AppBar, IconButton } from './styles';
import { ChangeContext } from './components/ChangeContext';
import { AppStateType } from '~/store/modules/root-reducer';
import { useSelector } from 'react-redux';
import { UserAuthInterface } from '~/store/modules/auth/auth-interface';
import { USER_ROLE } from '~/constants';

type AppBarProps = {
  theme: {};
  onDrawerToggle: React.MouseEventHandler<HTMLElement>;
};

const AppBarComponent: React.FunctionComponent<AppBarProps> = ({ onDrawerToggle }) => {
  const isStep1 = historyRef.current?.history?.location?.pathname?.includes('/step1');
  const { user }: { user: UserAuthInterface } = useSelector((state: AppStateType) => state.auth);

  return (
    <>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center">
            <Hidden xlUp>
              <Grid item>
                <IconButton color="inherit" aria-label="Open drawer" onClick={onDrawerToggle}>
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item xs />
            <Grid item>
              {(user?.originalUserExternalCode ||
                (user?.userRole !== USER_ROLE.VENDOR &&
                  user?.userRole !== USER_ROLE.TELEMARKETING &&
                  user?.userRole !== USER_ROLE.MAINTENANCE)) && <ChangeContext />}
              <NotificationsDropdown />
              <Settings isStep1={isStep1} />
              <UserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default withTheme(AppBarComponent);
